import Analytics from '@components/Analytics'
import CookieConsentBanner from '@components/CookieConsentBanner'
import React from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'
import FooterView from './SPA/components/Footer/FooterView'
import GlobalDialogForms from './SPA/components/GlobalDialogForms'
import HeaderBase from './SPA/components/Header/HeaderBase'

import LoaderView from './SPA/components/Misc/LoaderView'
import ScrollBtn from './SPA/components/Misc/ScrollBtn'
import ScrollTop from './SPA/components/Misc/ScrollTop'
import { CartView } from './SPA/Pages/Cart'
import { WholesaleCartView } from './SPA/Pages/WholesaleCart'
import { FooterBlockPages } from './SPA/Pages/FooterBlockPages'
import HomeView from './SPA/Pages/Home/View'
import Page404 from './SPA/Pages/Page404'

import WholeSaleRoutes from './SPA/Pages/Wholesale/WholeSaleRoutes'
import {
  ACCOUNT_URL,
  BLOG_PATH,
  CART_URL,
  CATEGORY_URL,
  CHECKOUT_SUCCESS_URL,
  CHECKOUT_URL,
  COLLECTION_URL,
  INSPIRATION_LIST,
  ORDER_DETAILS_URL,
  PAGE_404_URL,
  PRODUCT_URL,
  PROFILE_URL,
  SEARCH_URL,
  WHOLESALE_CART_URL,
  WHOLESALE_CHECKOUT_URL,
  WHOLESALE_PATH,
} from './SPA/urls'

const CategoryView = React.lazy(() => import('./SPA/Pages/Category/CategoryView'))
const CollectionView = React.lazy(() => import('./SPA/Pages/Collection/View'))

const ProductView = React.lazy(() => import('./SPA/Pages/Product/View'))
const SearchView = React.lazy(() => import('./SPA/Pages/Search/SearchView'))
const BlogRouter = React.lazy(() => import('./SPA/Pages/Blog/BlogRouter'))
const AccountView = React.lazy(() => import('./SPA/Pages/Account/AccountView'))
const CheckoutView = React.lazy(() => import('./SPA/Pages/Checkout/View'))
const WholesaleCheckoutView = React.lazy(() => import('./SPA/Pages/WholesaleCheckout/View'))
const OrderView = React.lazy(() => import('./SPA/Pages/Order/OrderView'))
const CheckoutSuccessView = React.lazy(() => import('./SPA/Pages/Checkout/CheckoutSuccess/CheckoutSuccessView'))
const FlatPageView = React.lazy(() => import('./SPA/Pages/FlatPage/FlatPageView'))

const UserProfileMainView = React.lazy(() => import('./SPA/Pages/UserProfile/UserProfileMainView'))
const SocialPostsView = React.lazy(() => import('./SPA/Pages/SocialPosts/View'))

const Routes: React.FC = () => {
  const location = useLocation()

  if (location.pathname.startsWith(WHOLESALE_PATH)) {
    return (
      <ScrollTop>
        <LoaderView />
        <GlobalDialogForms />
        <WholeSaleRoutes />
        <ScrollBtn />
        <CookieConsentBanner />
      </ScrollTop>
    )
  }
  return (
    <ScrollTop>
      <LoaderView />
      <GlobalDialogForms />
      <Analytics />
      <HeaderBase />
      <main className='container'>
        {/*<GoogleRatingBadge merchantId={GOOGLE_MERCHANT_ID} />*/}
        <Switch>
          <Route exact path='/'>
            <HomeView />
          </Route>
          <Route path={ACCOUNT_URL}>
            <React.Suspense fallback={null}>
              <AccountView />
            </React.Suspense>
          </Route>
          <Route exact path={CATEGORY_URL}>
            <React.Suspense fallback={null}>
              <CategoryView />
            </React.Suspense>
          </Route>
          <Route exact path={COLLECTION_URL}>
            <React.Suspense fallback={null}>
              <CollectionView />
            </React.Suspense>
          </Route>
          <Route exact path={PRODUCT_URL}>
            <React.Suspense fallback={null}>
              <ProductView />
            </React.Suspense>
          </Route>
          <Route exact path={SEARCH_URL}>
            <React.Suspense fallback={null}>
              <SearchView />
            </React.Suspense>
          </Route>
          <Route exact path={CHECKOUT_URL}>
            <React.Suspense fallback={null}>
              <CheckoutView />
            </React.Suspense>
          </Route>
          <Route exact path={WHOLESALE_CHECKOUT_URL}>
            <React.Suspense fallback={null}>
              <WholesaleCheckoutView />
            </React.Suspense>
          </Route>
          <Route exact path={CART_URL}>
            <CartView />
          </Route>
          <Route exact path={WHOLESALE_CART_URL}>
            <WholesaleCartView />
          </Route>
          <Route exact path={ORDER_DETAILS_URL}>
            <React.Suspense fallback={null}>
              <OrderView />
            </React.Suspense>
          </Route>
          <Route exact path={CHECKOUT_SUCCESS_URL}>
            <React.Suspense fallback={null}>
              <CheckoutSuccessView />
            </React.Suspense>
          </Route>
          <Route path={PROFILE_URL}>
            <React.Suspense fallback={null}>
              <UserProfileMainView />
            </React.Suspense>
          </Route>
          <Route path={BLOG_PATH}>
            <React.Suspense fallback={null}>
              <BlogRouter />
            </React.Suspense>
          </Route>
          <Route path={INSPIRATION_LIST}>
            <React.Suspense fallback={null}>
              <SocialPostsView />
            </React.Suspense>
          </Route>

          <Route path={PAGE_404_URL} component={Page404} />

          <Route path='/:block/:page'>
            <FooterBlockPages />
          </Route>
          <Route path='/:flatpage/'>
            <React.Suspense fallback={null}>
              <FlatPageView />
            </React.Suspense>
          </Route>
          <Route path='*' component={Page404} />
        </Switch>
      </main>
      <FooterView />
      <ScrollBtn />
      <CookieConsentBanner />
    </ScrollTop>
  )
}

export default Routes
